import { AlertGroupDetailsSidepanelWebComponent } from './component/AlertGroupDetailsSidepanelWebComponent';

export { AlertGroupDetailsSidepanelWebComponent };
